import { User } from '@/shared/user';
import store from '@/store';
import router from '@/router';
import { UserAssignedToPartnerPractice } from '@/shared/events/user-assigned-to-partner-practice';

async function handleUserAssignedToPartnerPractice(data: UserAssignedToPartnerPractice): Promise<void> {
    const currentUser: User | null = store.getters['user/user'];

    // If the notification is not for the current user or was changed by the current user for themselves,
    // don't need to show.
    if (currentUser == null || data.aggregateId !== currentUser.id || data.userId === currentUser.id) {
        return;
    }

    const isAdmin: boolean = store.getters['user/isAdministrator'];
    const isInternalKeyStakeholder: boolean = store.getters['user/isInternalKeyStakeholder'];

    if (!(isAdmin || isInternalKeyStakeholder) && currentUser.partnerPracticeId !== data.partnerPracticeId) {
        router.push({ name: 'home' });
    }
}

export default handleUserAssignedToPartnerPractice;
